const CreateCampaignStyles = (theme) => ({
	dialogPaper: {
		minHeight: '75vh'
	},
	stepper: {
		margin: theme.spacing.unit,
		position: "fixed",
		bottom: theme.spacing.unit
	},
	closeButton: {
		marginLeft: -20
	},
	typography: {
		marginBottom: 10
	},
	wrapper: {
		position: 'relative'
	},
	buttonProgress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -9,
		marginLeft: -9
	},
	submit: {
		marginTop: theme.spacing.unit * 2,
		marginBottom: theme.spacing.unit
	}
});

export default CreateCampaignStyles;
